import { useApp } from '../context.js';
import { Heart, Settings } from '../icons.jsx';

export default function Header() {
    const { activeTab, currentProfile, profilePhotos, setActiveTab, setShowSettings, sync, t } = useApp();
    // Honest sync dot: green Live, amber Syncing, gray Offline, red Sync error, gray Connecting before the first snapshot
    const dot = {
        live: { text: 'Live', color: 'text-green-500', bg: 'bg-green-500', pulse: true },
        syncing: { text: 'Syncing…', color: 'text-amber-500', bg: 'bg-amber-500', pulse: true },
        offline: { text: 'Offline, changes will sync', color: 'text-gray-500', bg: 'bg-gray-400', pulse: false },
        error: { text: 'Sync error', color: 'text-red-500', bg: 'bg-red-500', pulse: false },
        cache: { text: 'Connecting…', color: 'text-gray-500', bg: 'bg-gray-400', pulse: true },
    }[sync] || { text: 'Live', color: 'text-green-500', bg: 'bg-green-500', pulse: true };
    const tab = (key) => `flex-1 py-3 px-2 rounded-2xl font-semibold transition-all apple-button ${activeTab === key ? t.tabActive : t.tabInactive}`;
    return (
        <div className={`sticky top-0 bg-gradient-to-br ${t.bg} pt-6 pb-4 z-10`}>
            <div className="text-center animate-fadeIn">
                <div className="flex items-center justify-between mb-2">
                    <button
                        onClick={() => setShowSettings(true)}
                        className="w-10 h-10 rounded-full bg-white shadow-md flex items-center justify-center apple-button text-gray-600 hover:bg-gray-50"
                        title="Settings"
                        aria-label="Settings"
                    >
                        <Settings size={20} />
                    </button>
                    <div className="flex items-center gap-2 overflow-visible">
                        <div className="p-1 flex-shrink-0"><Heart size={26} className="animate-heartbeat" /></div>
                        <h1 className="text-3xl font-bold text-gray-800">Our Restaurants</h1>
                        <div className="p-1 flex-shrink-0"><Heart size={26} className="animate-heartbeat" style={{ animationDelay: '0.3s' }} /></div>
                    </div>
                    <div className="w-10"></div>
                </div>
                <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full ${
                    currentProfile === 'doug'
                        ? 'bg-blue-100 text-blue-700'
                        : 'bg-pink-100 text-pink-700'
                } font-semibold text-sm`}>
                    {profilePhotos[currentProfile] ? (
                        <img src={profilePhotos[currentProfile]} alt={currentProfile} className="w-6 h-6 rounded-full object-cover" />
                    ) : (
                        <span>{currentProfile === 'doug' ? '💛' : '💖'}</span>
                    )}
                    <span>{currentProfile === 'doug' ? 'Doug' : 'Les'}</span>
                </div>
                <p className={`text-xs ${dot.color} mt-1 flex items-center gap-1`} role="status">
                    <span className={`w-2 h-2 ${dot.bg} rounded-full ${dot.pulse ? 'animate-pulse' : ''}`}></span>
                    {dot.text}
                </p>
            </div>

            {/* Tab Navigation */}
            <div className="flex gap-2 mt-4" role="tablist">
                <button role="tab" aria-selected={activeTab === 'restaurants'} onClick={() => setActiveTab('restaurants')} className={tab('restaurants')}>
                    🍽️ Places
                </button>
                <button role="tab" aria-selected={activeTab === 'map'} onClick={() => setActiveTab('map')} className={tab('map')}>
                    🗺️ Map
                </button>
                <button role="tab" aria-selected={activeTab === 'stats'} onClick={() => setActiveTab('stats')} className={tab('stats')}>
                    📊 Stats
                </button>
            </div>
        </div>
    );
}
